module.exports = __webpack_public_path__ + "img/Home_quer.03cb2b08.jpg";